"use client";

import React from 'react';
import { 
  LayoutDashboard, 
  Users, 
  Calendar, 
  Library, 
  Zap, 
  BarChart3, 
  LogOut,
  ChevronRight
} from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useAuth();
  
  const menuItems = [
    { icon: <LayoutDashboard size={20} />, label: 'Dashboard', path: '/admin' },
    { icon: <BarChart3 size={20} />, label: 'Pipeline', path: '/admin/pipeline' },
    { icon: <Users size={20} />, label: 'Clientes', path: '/admin/clients' },
    { icon: <Calendar size={20} />, label: 'Workshops', path: '/admin/workshops' },
    { icon: <Library size={20} />, label: 'Recursos', path: '/admin/resources' },
    { icon: <Zap size={20} />, label: 'Automaciones', path: '/admin/automations' },
  ];

  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <aside className="w-64 bg-white border-r border-gray-200 flex flex-col h-screen sticky top-0">
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center font-bold text-white text-lg">M</div>
          <span className="font-bold text-lg text-charcoal">Admin <span className="text-primary">Lab</span></span>
        </div>
      </div>

      <nav className="flex-grow p-4 space-y-1">
        {menuItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex items-center justify-between px-4 py-3 rounded-xl transition-all group ${
              location.pathname === item.path 
                ? 'bg-blue-50 text-primary' 
                : 'text-charcoal-muted hover:bg-gray-50 hover:text-charcoal'
            }`}
          >
            <div className="flex items-center gap-3">
              {item.icon}
              <span className="font-semibold text-sm">{item.label}</span>
            </div>
            <ChevronRight size={14} className={`transition-transform ${location.pathname === item.path ? 'opacity-100' : 'opacity-0 group-hover:opacity-50'}`} />
          </Link>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-100">
        <button 
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 w-full text-red-500 hover:bg-red-50 rounded-xl transition-colors font-semibold text-sm"
        >
          <LogOut size={20} />
          Cerrar Sesión
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;